import React, { Component } from 'react';
import '../../inc/genstyle.css';
import IHeader from './ifragmentheader';
import ISidemenu from './ifragmentsidemenu';
import INA from './ifragmentna';
import Popup from '../../inc/popup';
import '../../inc/popup.css'
import DateTimeFormats from '../../inc/date-time-format';
import NumberFormats from '../../inc/number-format';
import ReplaceAllContent from '../../inc/replace-all';
import BudgetProjectForm from './ipopgcpbudget-project-form';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const authKey = global.config.authBearerKey+"##"+global.config.kindcode[48];

class IGCPBudgetsDetail extends Component {
  constructor (props) {
    super(props);
    this.state = {
        activelink: '',
        stTitle: "",
        budgetdoc_id: "",
        budget_name: "",
        company_domain: "",
        company_name: "",
        subcompany_name: "",
        created_name: "",
        created_date: "",
        cuan_company: {
          companyname: "",
          companyid: "",
          companydomain: ""
        },
        cuan_subcompany: {
          subcompanyid: "",
          subcompanyname: ""
        },
        currency: "",
        budget: "",
        contract_periode: "",
        duration_periode: "",
        long_periode: "",
        interval_periode: "",
        contract_startdate: "",
        contract_enddate: "",
        limit_alert: [],
        refer_to: "",
        periods: [],
        projects: [],
        isOpen: false,
        otherContent: '',
        
        showProjectPopup: false,
        newProject: {
          project_id_gcp: '',
          project_number_gcp: '',
          project_name_gcp: '',
          billing_account_id: ''
        }
        
    }
    this.loadData = this.loadData.bind(this);
    // this.normalizeToJsDate = this.normalizeToJsDate.bind(this);
    // this.loadPeriods = this.loadPeriods.bind(this);
    // this.loadProjects = this.loadProjects.bind(this);
    // this.resolveAndLoadProjects = this.resolveAndLoadProjects.bind(this);
    // this.toggleProjectPopup = this.toggleProjectPopup.bind(this);
    // this.handleProjectInput = this.handleProjectInput.bind(this);
    // this.submitNewProject = this.submitNewProject.bind(this);
  }
  
  normalizeToJsDate = (val) => {
    if (!val) return null;
    // Unwrap BigQuery-style object { value: '...' }
    if (typeof val === 'object' && val !== null && 'value' in val) {
      val = val.value;
    }
    if (val instanceof Date) return isNaN(val.getTime()) ? null : val;
    const str = val.toString().trim();
    let d = new Date(str);
    if (!isNaN(d.getTime())) return d;
    const m = str.match(/^(\d{4}-\d{2}-\d{2})\s(\d{2}:\d{2}:\d{2})$/);
    if (m) {
      d = new Date(`${m[1]}T${m[2]}Z`);
      return isNaN(d.getTime()) ? null : d;
    }
    const m2 = str.match(/^(\d{4}-\d{2}-\d{2})$/);
    if (m2) {
      d = new Date(`${m2[1]}T00:00:00Z`);
      return isNaN(d.getTime()) ? null : d;
    }
    return null;
  };

  handleBack = () => {
    window.location.href = global.config.urlOrigin + '/igcpbudget';
  }
  togglePopClose(name) {
    this.setState( prevState => {
      return {  
          ...prevState[name], [name]: false,
      }
    })
  }
  urlformProject(budgetId,project,type,data) {
    var dataContent = {};
    if(type==="edit" && data !== "") {
      var dataJson = JSON.parse(data);
      dataContent = {
        activelink: this.state.activelink,
        budget_docid: budgetId,
        project_docid: project,
        type: type,
        project_id_gcp: dataJson.project_id_gcp,
        project_number_gcp: dataJson.project_name_gcp,
        project_name_gcp: dataJson.project_number_gcp,
        billing_account_id: dataJson.billing_account_id,
        approved_by: dataJson.approved_by,
        company_domain: this.state.company_domain,
        company_name: this.state.company_name,
        subcompany_name: this.state.subcompany_name,
        cuan_company: this.state.cuan_company,
        cuan_subcompany: this.state.cuan_subcompany,
        refer_to: this.state.refer_to
      }
    } else {
      dataContent = {
        activelink: this.state.activelink,
        budget_docid: budgetId,
        project_docid: project,
        type: type,
        project_id_gcp: '',
        project_number_gcp: '',
        project_name_gcp: '',
        billing_account_id: '',
        approved_by: '',
        company_domain: this.state.company_domain,
        company_name: this.state.company_name,
        subcompany_name: this.state.subcompany_name,
        cuan_company: this.state.cuan_company,
        cuan_subcompany: this.state.cuan_subcompany,
        refer_to: this.state.refer_to
      }
    }
    this.setState( prevState => {
      return {  
          ...prevState.isOpen, isOpen: true,
          ...prevState.otherContent, otherContent: JSON.stringify(dataContent), 
      }
    })
  }


/*
  loadPeriods(budgetId) {
    fetch(global.config.herdisApiUrl+"/gcpbudgetperiode/"+budgetId, {
      method: 'GET',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
      }
    }).then(res => {
      if(res.status === 200) 
          return res.json() 
    }).then( resJson => {
      if(resJson && resJson.status === '200' && Array.isArray(resJson.values)) {
        this.setState({ periods: resJson.values });
      }
    }).catch(err => {
      
    });
  }

  loadProjects(companyId, subCompanyId, budgetId) {
    if ((companyId == null || companyId === '') && !subCompanyId) {
      this.setState({ projects: [] });
      return;
    }
    const params = new URLSearchParams();
    if (companyId != null && companyId !== '') params.append('companyId', companyId);
    if (subCompanyId) params.append('subCompanyId', subCompanyId);
    if (budgetId) params.append('budgetId', budgetId);
    fetch(global.config.herdisApiUrl+"/gcpprojects?"+params.toString(), {
      method: 'GET',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
      }
    }).then(res => {
      if(res.status === 200) 
          return res.json() 
    }).then( resJson => {
      if(resJson && resJson.status === '200' && Array.isArray(resJson.values)) {
        this.setState({ projects: resJson.values });
      }
    }).catch(err => {
      
    });
  }


  toggleProjectPopup(show) {
    this.setState({ showProjectPopup: show });
  }

  handleProjectInput(e) {
    const { name, value } = e.target;
    this.setState(prev => ({ newProject: { ...prev.newProject, [name]: value } }));
  }

  async submitNewProject() {
    const v = this.state.data || {};
    const payload = {
      row: {
        project_id_gcp: this.state.newProject.project_id_gcp,
        project_number_gcp: this.state.newProject.project_number_gcp,
        project_name_gcp: this.state.newProject.project_name_gcp,
        billing_account_id: this.state.newProject.billing_account_id,
        create_byId: localStorage.getItem('uid') || localStorage.getItem('utk') || '',
        create_byName: localStorage.getItem('ufullname') || '',
        // budget_id: v && (v.budget_doc_id || v.docid || v.id || v._id) || null,
        // cuan_companyName: v.cuan_companyName || v.company_name || '',
        // cuan_companyDomain: v.cuan_companyDomain || v.company_domain || '',
        // cuan_subcompanyName: v.cuan_subcompanyName || v.subcompany_name || '',
        // company_name: v.company_name || v.cuan_companyName || '',
        // company_domain: v.company_domain || v.cuan_companyDomain || '',
        // cuan_companyId: v.cuan_companyId || null,
        // cuan_subcompanyId: v.cuan_subcompanyId || null
      }
    };
    const resp = await fetch(global.config.herdisApiUrl+"/gcpprojectinsert", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      },
      body: JSON.stringify(payload)
    });
    const resJson = await resp.json();
    if (resp.status === 200 && resJson.status === '200') {
      this.toggleProjectPopup(false);
      this.setState({ newProject: { project_id_gcp: '', project_number_gcp: '', project_name_gcp: '', billing_account_id: '' } });
      if ((v.cuan_companyId == null || v.cuan_companyId === '') && !v.cuan_subcompanyId) {
        const appended = {
          ...payload.row,
          project_doc_id: resJson.project_doc_id
        };
        this.setState(prev => ({ projects: [...prev.projects, appended] }));
      } else {
        const budgetId = v && (v.budget_doc_id || v.docid || v.id || v._id);
        this.loadProjects(v.cuan_companyId, v.cuan_subcompanyId, budgetId);
      }
    } else {
      alert(resJson.error || 'Failed to insert project');
    }
  }
  

  async resolveAndLoadProjects(value) {
    try {
      let companyId = value && value.cuan_companyId;
      let subCompanyId = value && value.cuan_subcompanyId;
      const budgetId = value && (value.budget_doc_id || value.docid || value.id || value._id);
      const companyName = (value && (value.company_name || value.cuan_companyName)) || '';
      const subName = (value && (value.subcompany_name || value.cuan_subcompanyName)) || '';
      if (!companyId && companyName) {
        const resp = await fetch('https://cuancuan.point-star.com/api/get/company_groups', {
          method: 'GET',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
        });
        const j = resp.ok ? await resp.json() : null;
        const arr = Array.isArray(j) ? j : (Array.isArray(j?.data) ? j.data : []);
        const match = arr.find(i => (i?.company_group_name || i?.name || '').toString() === companyName);
        companyId = match ? (match.company_group_id || match.id) : companyId;
      }
      if (!subCompanyId && subName) {
        const base = 'https://cuancuan.point-star.com/api/get/subsidiaries';
        const url = companyId ? `${base}?company_group_id=${encodeURIComponent(companyId)}` : base;
        const resp2 = await fetch(url, {
          method: 'GET',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
        });
        const j2 = resp2.ok ? await resp2.json() : null;
        const arr2 = Array.isArray(j2) ? j2 : (Array.isArray(j2?.data) ? j2.data : []);
        const match2 = arr2.find(i => (i?.subsidiary_name || i?.subcompany_name || i?.name || '').toString() === subName);
        subCompanyId = match2 ? (match2.subsidiary_id || match2.subcompany_id || match2.id) : subCompanyId;
      }
      if (companyId || subCompanyId) {
        this.loadProjects(companyId, subCompanyId, budgetId);
      } else {
        this.setState({ projects: [] });
      }
    } catch (e) {
      this.setState({ projects: [] });
    }
  }
*/  

  urldeleteProject(subid,id){
    var stat = false;
    stat = window.confirm("Are you sure you want to delete this data?");
    if(stat === true) {
      document.getElementById('loading-area').style.display = 'block'; 
        var urlString = global.config.urlLink+"/gcpbudgetprojectdelete";
        var data = {
          docid: id,
          subdocid: subid,
          form_id: "delete-projectbudget"
        }
        fetch(urlString, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': authKey,
            }, body : JSON.stringify(data)
          }).then(res => {
            if(res.status === 200) 
                return res.json() 
          }).then( resJson => {
            document.getElementById('loading-area').style.display = 'none'; 
            if(resJson.status === '200') {
                this.loadData(this.state.activelink,this.state.budgetdoc_id)
            } else {
                console.log('Something happened wrong');
            }
          }).catch(err => err);
    }
  }

  alertList(data1,type) {
    var arrAlertList = [];
    if(data1.length > 0) { 
      var a=1;
      data1.forEach((list) => {
        if(list !== "" && list !== null && list !== undefined) {
          if(type==="rows") {
            arrAlertList.push(<span>{list*100}%, </span>);
          } else {
            arrAlertList.push(<div>#{a}: {list*100}% from budget.</div>);
          }
          a++;
        }
      })
    }
    return arrAlertList;
  }

  periodBudgetList(data3) {
    var arrPeriodList = [];
    if(data3.length > 0) {
      data3.sort((a, b) => new Date(a.start_periode.value) - new Date(b.start_periode.value))
      data3.forEach((list3,idx3) => {
        arrPeriodList.push(<tr key={idx3+1}>
          <th scope="row">{idx3+1}</th>
          <td>{DateTimeFormats(list3.start_periode.value,"date-short","BQ") || '-'}</td>
          <td>{DateTimeFormats(list3.end_periode.value,"date-short","BQ") || '-'}</td>
          <td>{list3.currency + " " + NumberFormats(list3.budget) || '-'}</td>
          <td>{
              this.alertList([list3.limit_alert_1,list3.limit_alert_2,list3.limit_alert_3,list3.limit_alert_4,list3.limit_alert_5],"rows")
            }
          </td>
          
        </tr>)
      })

    } else {
      arrPeriodList.push(<tr key="0">
            <td colSpan="5" className="textCenter"><div className="mgT20 mgB20">:: no record ::</div></td>
          </tr>)
    }
    return arrPeriodList;
  }

  projectList(data2) {
    var arrProjectsList = [];
    if(data2.length > 0) {
      data2.forEach((list2,idx2) => {
        arrProjectsList.push(<tr key={idx2+1}>
          <th scope="row">{idx2+1}</th>
          <td>{list2.approved_by || '-'}</td>
          <td>{list2.project_id_gcp || '-'}</td>
          <td>{list2.project_number_gcp || '-'}</td>
          <td>{list2.project_name_gcp || '-'}</td>
          <td>{list2.billing_account_id || '-'}</td>
          <td>
            <EditIcon className="iconGrey mgR05 cursor-on" alt="edit" style={{fontSize:"15pt"}} onClick={this.urlformProject.bind(this, list2.budget_id, list2.project_doc_id, 'edit',JSON.stringify(list2))}/>
            <DeleteIcon className="iconGrey cursor-on" alt="remove" style={{fontSize:"15pt"}} onClick={this.urldeleteProject.bind(this, list2.budget_id, list2.project_doc_id)}/>
          </td>
        </tr>)
      })

    } else {
      arrProjectsList.push(<tr key="0">
            <td colSpan="6" className="textCenter"><div className="mgT20 mgB20">:: no record ::</div></td>
          </tr>)
    }
    return arrProjectsList;
  }


  loadData(element,id) {
    if(element.toLowerCase() === "iviewgcpbudget") {
      document.getElementById('loading-area').style.display = 'block'; 
      // fetch(global.config.herdisApiUrl+"/gcpbudgetview/"+id, {
      fetch(global.config.urlLink+"/gcpbudgetview/"+id, {
          method: 'GET',
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'Authorization': authKey,
          }
        }).then(res => {
          if(res.status === 200) 
              return res.json() 
        }).then( resJson => {
          document.getElementById('loading-area').style.display = 'none'; 
          if(resJson.status === '200') {
            var results = resJson.values[0].content[0];
            var createDate = DateTimeFormats(this.normalizeToJsDate(results.create_date),"datetime-long","BQ");
            var contractSDate = DateTimeFormats(this.normalizeToJsDate(results.start_contract_periode),"date-short","BQ");
            var contractEDate = DateTimeFormats(this.normalizeToJsDate(results.end_contract_periode),"date-short","BQ");
            this.setState({
              activelink: element.toLowerCase(),
              stTitle: "Detail Budget ",
              // data: results,
              budgetdoc_id: results.budget_doc_id,
              budget_name: results.budget_name,
              company_domain: results.company_domain,
              company_name: results.company_name,
              subcompany_name: results.subcompany_name,
              created_name: results.create_byName,
              created_date: createDate,
              cuan_company: {
                companyname: results.cuan_companyName,
                companyid: results.cuan_companyId,
                companydomain: results.cuan_companyDomain
              },
              cuan_subcompany: {
                subcompanyid: results.cuan_subcompanyId,
                subcompanyname: results.cuan_subcompanyName
              },
              currency: results.currency,
              budget: results.budget,
              contract_periode: results.contract_periode,
              duration_periode: results.duration_periode,
              long_periode: results.long_periode,
              interval_periode: results.interval_periode,
              contract_startdate: contractSDate,
              contract_enddate: contractEDate,
              limit_alert: [
                results.limit_alert_1,
                results.limit_alert_2,
                results.limit_alert_3,
                results.limit_alert_4,
                results.limit_alert_5
              ],
              refer_to: results.refer_to,
              approved_by: results.approved_by,
              periods: resJson.values[0].scontent,
              projects: resJson.values[0].scontent2
            });

          } else {
              console.log('Something happened wrong');
          }
        }).catch(err => {
          document.getElementById('loading-area').style.display = 'none'; 
        }); 
    }
  }

  componentDidMount() {
    var arrString = window.location.pathname; 
    var arrUrl = [];
    arrUrl = arrString.split('/');
    
    if(arrUrl[1].toLowerCase() === 'iviewgcpbudget') {
        if(arrUrl[2] !== '') { 
            this.loadData(arrUrl[1],arrUrl[2]);
        }
    } 
  }

  render() {

   return (
    <div className="main-container">
      <div  className="header-main"><IHeader/></div>
          <div className="flex-container">
              <div className="sidebar-main"><ISidemenu/></div>
              <div className="main-content">
              <div className="stTitle">Client's Budget GCP</div>
                {((localStorage.getItem('ulevel') === global.config.userlevel[0]) || (JSON.parse(localStorage.getItem('urole'))[9] === "ON") )? 
                <div>
                  <div className="stIndiTitle">
                    Client's Budget GCP
                    { this.state.stTitle !== ''? ' > '+this.state.stTitle : '' }
                  </div>
                  <div className="mgT30">
                    {/* ====== */}
                    <div className="content-container card card-body">
                      <div className="flex-container">
                          <div className=" w70p">
                            <small>Budget Name: </small><br/>
                            <h4>{this.state.budget_name}</h4>
                          </div>
                          <div className="divRight w30p"><div><button className="backButton" onClick={this.handleBack}>&#9664; back</button></div></div>
                      </div>
                      <div><h5 className="detailJoined">created date : {this.state.created_date}, <span className='ml-2'>by: {this.state.created_name}</span></h5></div>

                      <div id="details" className="mgT20">
                        <div className="row">
                          <div className="col-6">
                              <div id="budget-info">
                                  <div className="row">
                                    <div className="col-4"><p>Budget</p></div>
                                    <div className="col-8">{this.state.currency} {NumberFormats(this.state.budget)} / {this.state.long_periode} {this.state.duration_periode}</div>
                                  </div>
                                  <div className="row">
                                    <div className="col-4"><p>Period of Contract</p></div>
                                    <div className="col-8">
                                      {this.state.contract_periode} {this.state.duration_periode} <br/>
                                      <label className="mt-1 p-2" style={{backgroundColor:"#E1E1E1"}}>{this.state.contract_startdate}  <span className="ml-3 mr-3">s/d</span> {this.state.contract_enddate} </label>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-12"><div className="textBold textItalic">this budget is valid for one {
                                      global.config.gcpbudgetReference.filter(rf => rf.value === this.state.refer_to).label
                                    }</div></div>
                                  </div>
                                  <div id="alert-info" className="w100p mgT30">
                                    <div className="picContainer w100p">
                                      {(this.state.limit_alert.length>0)? 
                                        <div className="w100p">
                                          <p>Email notification will be sent when the bill has reached the budget limit.</p>
                                          {this.alertList(this.state.limit_alert)}

                                        </div>
                                      : <div className="w100p"></div> }
                                    </div>
                                    {/* <div className="picContainer w100p">
                                    {amList}
                                    </div> */}
                                    
                                </div>
                              </div>
                          </div>
                          <div className="col-6">
                            <div className='mb-3'>
                              <h6 className='textBold'>Company Info </h6>
                              {this.state.company_name} 
                              {this.state.subcompany_name !== "" && ` > `+this.state.subcompany_name}
                              <br/>({this.state.company_domain})
                            </div>
                            <div className="picContainer w100p" style={{maxHeight:"310px"}}>
                              <div className='mb-2 textUnderline'><b>{this.state.company_name}</b> Info in Cuan-Cuan</div>
                              <div className="row">
                                <div className="col-4">Company Name</div>
                                <div className="col-8">: {this.state.cuan_company.companyname}</div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-4">Company Domain</div>
                                <div className="col-8">: {this.state.cuan_company.companydomain}</div>
                              </div>
                              {this.state.cuan_subcompany.subcompanyname !== "" && <div className="row mt-2">
                                <div className="col-4">Subsidiary Name</div>
                                <div className="col-8">: {this.state.cuan_subcompany.subcompanyname}</div>
                              </div>}
                              
                            </div>
                          
                          </div>
                        </div>
                      </div>
                      
                      <div className="mgT50" id="projectgcp-area">
                        <div className="flex-container">
                          <div className="w70p st3Title divMiddle">GCP Projects</div>
                          <div className="w30p divRight">
                            <button className="genButton mgL20" onClick={this.urlformProject.bind(this, this.state.budgetdoc_id,'','add','')}><AddCircleOutlineIcon className="iconWhite mgR05"></AddCircleOutlineIcon>Add GCP Project</button>
                          </div>
                        </div>
                        <div className="mgT20">
                          <table className="table table-hover">
                            <thead className="thead-light">
                                <tr>
                                  <th scope="col">#</th>
                                  <th scope="col">Usage for</th>
                                  <th scope="col">Project ID</th>
                                  <th scope="col">Project Number</th>
                                  <th scope="col">Project Name</th>
                                  <th scope="col">Billing Account</th>
                                  <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.projectList(this.state.projects)}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="mgT50" id="projectgcp-area">
                        <div className="flex-container">
                          <div className="w70p st3Title divMiddle">Breakdown Budget Period</div>
                          <div className="w30p divRight">
                            
                          </div>
                        </div>
                        <div className="mgT20">
                          <table className="table table-hover">
                            <thead className="thead-light">
                                <tr>
                                  <th scope="col">#</th>
                                  <th>Start Periode</th>
                                  <th>End Periode</th>
                                  <th>Budget</th>
                                  <th>Alert Limits</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.periodBudgetList(this.state.periods)}
                            </tbody>
                          </table>
                        </div>
                      </div>

                  </div>
                  {/* ====== */}
                </div>  
                
                <div>
                  {this.state.isOpen && <Popup
                      content={<><BudgetProjectForm/></>}
                      id={this.state.budgetdoc_id} 
                      title={"GCP Project"}
                      others={this.state.otherContent}
                      styles={"50%"}
                      handleClose={this.togglePopClose.bind(this, 'isOpen', this.state.budgetdoc_id)}
                    />}
                </div>
              </div>
              :   
              <div><INA/></div>
              }
            </div>
          </div>
          <div id="loading-area" className="divHide loading"></div>
    </div>
   );
  }
}
 
export default IGCPBudgetsDetail;